module.exports = __webpack_public_path__ + "img/img35.3a251628.svg";